export { BatterySeventyFiveIcon } from "./battery-seventy-five";
